import { useCollectionThreadsQuery } from '#pplx/frontend/apps/ask/hooks/collections-hooks/useCollectionThreadsQuery.js';
import { getPinnedFirstSpaceThreads, SPACE_THREAD_LIMIT, } from '#pplx/frontend/apps/ask/layout/sidebar/core/lite/SpaceItemsSharedSupport.js';
import { getSpacePinnedThreadsQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/spacesKeys.js';
import { listSpacePinnedThreads } from '#pplx/frontend/apps/ask/queries/spaces-queries/listSpacePinnedThreads.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { useMemo } from 'react';
export function useSpaceThreads({ spaceUuid, spaceSlug, }) {
    const { data: pinnedThreads = EMPTY_ARRAY, isLoading: isPinnedThreadsLoading, isError: isPinnedThreadsError, } = useQuery({
        queryKey: getSpacePinnedThreadsQueryKey({ spaceUuid, limit: SPACE_THREAD_LIMIT }),
        queryFn: () => listSpacePinnedThreads({
            spaceUuid,
            limit: SPACE_THREAD_LIMIT,
            reason: 'sidebar-promoted-space-pinned-threads',
            throwOnError: true,
        }),
        enabled: Boolean(spaceUuid),
    });
    const { threads: recentThreads, query: { isLoading: isRecentThreadsLoading, isError: isRecentThreadsError }, } = useCollectionThreadsQuery({
        collectionSlug: spaceSlug,
        includeUserAndSharedThreads: true,
        autoFetch: Boolean(spaceSlug &&
            !isPinnedThreadsLoading &&
            !isPinnedThreadsError &&
            pinnedThreads.length < SPACE_THREAD_LIMIT),
        limit: SPACE_THREAD_LIMIT,
        reason: 'sidebar-promoted-space-recent-threads',
        throwOnError: true,
    });
    const threads = useMemo(() => getPinnedFirstSpaceThreads({ pinnedThreads, recentThreads }), [pinnedThreads, recentThreads]);
    const isLoading = isPinnedThreadsLoading || isRecentThreadsLoading;
    const isError = (isPinnedThreadsError || isRecentThreadsError) && threads.length === 0;
    return useMemo(() => ({ threads, isLoading, isError }), [threads, isLoading, isError]);
}
//# sourceMappingURL=useSpaceThreads.js.map